import {Component, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {RemedialService} from "../../../_services/remedial.service";
import {ActivatedRoute} from "@angular/router";
import {Remedial} from "../../../_models/Remedial";
import {CommonModule} from "@angular/common";
import {NgxDropzoneModule} from "ngx-dropzone";
import {FormBuilder, FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {RemedialStatus} from "../../../_models/RemedialStatus";
import {BaseComponent} from "../../../shared/base-component";
import {ToastrService} from "ngx-toastr";
import {RemedialImagesComponent} from "../../../shared/remedial-images/remedial-images.component";
import {catchError, map} from "rxjs/operators";
import {of} from "rxjs";
import {LabeledDisplayComponent} from "../../../shared/labeled-display/labeled-display.component";
import {LabeledInputComponent} from "../../../shared/labeled-input/labeled-input.component";

@Component({
  templateUrl: "./remedial-details.component.html",
  imports: [
    LabeledDisplayComponent,
    CommonModule,
    NgxDropzoneModule,
    ReactiveFormsModule,
    RemedialImagesComponent,
    LabeledInputComponent
  ],
  encapsulation: ViewEncapsulation.None
})

export class RemedialDetailsComponent extends BaseComponent implements OnInit {
  @ViewChild(RemedialImagesComponent) remedialImages: RemedialImagesComponent;

  constructor(private remedialService: RemedialService, private route: ActivatedRoute, private formBuilder: FormBuilder, protected toaster: ToastrService) {
    super(toaster);
  }

  remedialForm = this.formBuilder.group({
    id: new FormControl(null),
    name: new FormControl(null, [Validators.required]),
    description: new FormControl(null, [Validators.required]),
    adminbaseCallNumber: new FormControl(null, [Validators.min(0)]),
    serialNumber: new FormControl(null, [Validators.required]),
    estimatedCost: new FormControl(null, [Validators.min(0)]),
    quoteId: new FormControl(null),
    park: new FormControl(null, [Validators.required]),
    plot: new FormControl(null, [Validators.required]),
    installationDate: new FormControl(null),
    contractNumber: new FormControl(null, [Validators.required]),
    chargeable: new FormControl(false),
    chargeableCost: new FormControl(null, [Validators.min(0)])
  })

  public remedialId: string;
  public remedial: Remedial;
  canUpdate: boolean = false;
  fileContents: string[] = [];
  files: File[] = [];
  showCamera: boolean = false;
  showDocUpload: boolean = false;


  ngOnInit() {
    this.remedialId = this.route.snapshot.paramMap.get('id');
    this.getRemedial();
  }

  private getRemedial() {
    this.remedialService.getRemedial(this.remedialId).subscribe(remedial => {
      this.remedial = remedial;
      this.remedialForm.patchValue(remedial);

      this.canUpdate =
        (this.remedial.status === RemedialStatus.New || this.remedial.status === RemedialStatus.PendingApproval
          || this.remedial.status === RemedialStatus.PendingInformation || this.remedial.status == RemedialStatus.TraceRequest)
        && !this.remedial.adminbaseCallNumber;
    });
  }

  submitForm() {
    if(this.remedialForm.invalid) {
      this.showAllFormValidation(this.remedialForm);
      return;
    }

    const remedial: any = this.remedialForm.value;
    let images = this.remedialImages.webcamImages.map(x => x.imageAsBase64).concat(this.fileContents)

    this.remedialService.updateRemedial(remedial, images)
      .pipe(
        map(r => {
          this.toasterService.success('Remedial updated');
          this.files = [];
          this.fileContents = [];
          this.getRemedial();
        }),
        catchError(e => {
          this.showErrorToast(e);
          return of();
        }))
      .subscribe();
  }

  uploadImages() {
    this.showCamera = false;
    this.showDocUpload = true;
  }

  showWebcam() {
    this.showCamera = true;
    this.showDocUpload = false;
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);

    this.fileContents = [];
    this.files.map(x => this.readFile(x).then(result => this.fileContents.push(result)));
  }

  private async readFile(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = e => {
        return resolve((e.target as FileReader).result.toString().split(',')[1]);
      };

      reader.onerror = e => {
        console.error(`FileReader failed on file ${file.name}.`);
        return reject(null);
      };

      if (!file) {
        console.error('No file to read.');
        return reject(null);
      }

      reader.readAsDataURL(file);
    });
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);

    this.fileContents = [];
    this.files.map(x => this.readFile(x).then(result => this.fileContents.push(result)));
  }
}
